import GuaranteeIcon from "assets/guarantee.svg";
import CartIcon from "assets/green-cart.svg";
import { CollapsibleItem } from "components/UI/molecules/collapsible-item";
import "./index.scss";
import { GUARANTEE_ITEMS, GUARANTEE_TEXT } from "./utils/constants";

export const CartGuarantee = () => {
  return (
    <section className="cart-guarantee">
      <section>
        <div className="guarantee-shield">
          <img alt="cart icon" src={GuaranteeIcon} className="icon" />
          <h3 className="guarantee-title">90 Day Money-Back Guarantee</h3>
        </div>
        <p className="guarantee-text">{GUARANTEE_TEXT}</p>
      </section>
      <div className="border" data-testid="border-element" />
      <section className="order">
        <div className="order-about">
          <img alt="cart icon" src={CartIcon} className="icon" />
          <h3 className="order-title">About Your Order</h3>
        </div>

        <CollapsibleItem
          key="giftCardQuestion"
          label="Are you buying this gift card
              for someone else?"
          keepOpen={true}
        >
          <span>
            Make sure that you are buying this gift card for someone you know.
            Find more information from the{" "}
            <a
              className="link"
              href="https://www.consumer.ftc.gov/articles/paying-scammers-gift-cards"
              rel="noopener noreferrer"
              target="_blank"
              aria-label="FTC here"
            >
              FTC here
            </a>
            .
          </span>
        </CollapsibleItem>
        {GUARANTEE_ITEMS.map((props) => (
          <div key={props.label}>
            <div className="border" data-testid="border-element" />
            <CollapsibleItem label={props.label}>{props.text}</CollapsibleItem>
          </div>
        ))}
      </section>
    </section>
  );
};
